<script setup lang="ts">
defineProps<{
  title: string;
  description: string;
  value: boolean;
}>();
</script>

<template>
  <div
    class="rounded bordered p-3"
    :class="value ? 'text-dark' : 'text-grey inactive-background'"
  >
    <div class="d-flex align-items-center mb-1 gap-3">
      <el-icon size="1.2rem" :class="value ? 'text-success' : 'text-grey'"
        ><i :class="value ? 'bi-check-circle-fill' : 'bi-dash-circle-fill'"></i
      ></el-icon>
      <span class="fs-5">{{ title }}</span>
    </div>
    <div class="fw-normal">{{ description }}</div>
  </div>
</template>

<style lang="scss" scoped>
.inactive-background {
  background-color: rgba(128, 128, 128, 0.094);
}
</style>
